import { getCanvaFileId } from "@/utils/getCanvaFileId";

const canvaHostnames = ["canva.com", "www.canva.com"];

export const validateCanvaURL = (value: string) => {
  const trimmedValue = value.trim();

  try {
    const url = new URL(
      trimmedValue.includes("://") ? trimmedValue : `https://${trimmedValue}`,
    );
    const isCanvaDesignUrl =
      canvaHostnames.includes(url.hostname.toLowerCase()) &&
      url.pathname.split("/").filter(Boolean)[0] === "design";
    const isCanvaShortLink =
      url.hostname.toLowerCase() === "canva.link" &&
      Boolean(url.pathname.split("/").filter(Boolean)[0]);

    return Boolean(
      (isCanvaDesignUrl && getCanvaFileId(trimmedValue)) || isCanvaShortLink,
    );
  } catch {
    return false;
  }
};
